import ReactMarkdown from 'react-markdown'

interface MarkdownRendererProps {
    children: string
    className?: string
}

const MarkdownRenderer = ({ children, className = '' }: MarkdownRendererProps) => {
    return (
        <ReactMarkdown
            className={className}
            components={{
                p: ({ children }) => <p className='mb-2 last:mb-0'>{children}</p>,
                strong: ({ children }) => <strong className='font-semibold'>{children}</strong>,
                em: ({ children }) => <em className='italic'>{children}</em>,
                code: ({ children }) => (
                    <code className='px-1 py-0.5 bg-gray-100 rounded text-xs font-mono'>{children}</code>
                ),
                ul: ({ children }) => <ul className='list-disc list-inside mb-2'>{children}</ul>,
                ol: ({ children }) => <ol className='list-decimal list-inside mb-2'>{children}</ol>,
                li: ({ children }) => <li className='mb-1'>{children}</li>,
                a: ({ href, children }) => (
                    <a href={href} className='text-blue-600 hover:underline' target='_blank' rel='noopener noreferrer'>
                        {children}
                    </a>
                ),
            }}
        >
            {children}
        </ReactMarkdown>
    )
}

export default MarkdownRenderer
